import { lazy, Suspense } from 'react'

import SuspenseLoader from '~/core/SuspenseLoader'

/**
 * Wraps page dynamic import with react's lazy loading and Suspense for loading state
 * @param args
 */
export const suspend = <Props extends Record<string, any>>(
    ...args: Parameters<typeof lazy>
) => {
    const LazyPage = lazy(...args)

    return (props: Props) => (
        <Suspense fallback={<SuspenseLoader />}>
            <LazyPage {...props} />
        </Suspense>
    )
}
